import { V3Models } from "@istari/istari-client";

import { InfosecLevel } from "~/resource/model/infosec-level";

export function toInfosecLevel(sdkLevel: V3Models.InfosecLevel | null | undefined): InfosecLevel | undefined {
  if (!sdkLevel) {
    return undefined;
  }

  return {
    id: sdkLevel.id,
    name: sdkLevel.name,
    order: sdkLevel.order,
    displayColor: sdkLevel.displayColor,
  };
}
